export default function initializeForm() {
  document.addEventListener("DOMContentLoaded", function () {
    /***************************************************************************
     ** upload input
     */

    const uploadInput = document.querySelector('.js-upload');
    const parentEl = uploadInput.closest('.upload-button-wrap');
    const uploadButton = parentEl.querySelector('.button--upload');

    // set width and height of upload input field according to button
    const buttonRect = uploadButton.getBoundingClientRect();
    resizeInput(uploadInput, uploadButton)

    uploadInput.addEventListener('change', function (event) {
      if(event.target.files.length > 0){
        parentEl.querySelector('.js-clear-upload').classList.remove('hidden');
        parentEl.querySelector('.js-label-upload').textContent = event.target.files[0].name;

        // resize input field according to button
        const targetButton = parentEl.querySelector('.button--upload');
        const targetInput = parentEl.querySelector('.js-upload');
        resizeInput(targetInput, targetButton)
      }
      else {
        parentEl.querySelector('.js-label-upload').textContent = parentEl.querySelector('.js-label-upload').dataset.default;
      }
    });

    const clearUploadButton = document.querySelector('.js-clear-upload');
    clearUploadButton.style.height = buttonRect.height + 'px';

    clearUploadButton.addEventListener('click', function (event) {
      event.preventDefault();

      const parentEl = event.target.closest('.upload-button-wrap');
      const uploadInput = parentEl.querySelector('.js-upload');
      uploadInput.value = '';
      uploadInput.focus();
      uploadInput.dispatchEvent(new Event('change'));
      event.preventDefault();

      parentEl.querySelector('.js-clear-upload').classList.add('hidden');
      parentEl.querySelector('.js-label-upload').textContent = parentEl.querySelector('.js-label-upload').dataset.default;

      // resize input field according to button
      const targetButton = parentEl.querySelector('.button--upload');
      resizeInput(uploadInput, targetButton)
    });

    window.addEventListener('resize', function () {
      const uploadInput = document.querySelector('.js-upload');
      if(uploadInput.files.length > 0){
        uploadInput.dispatchEvent(new Event('change'));
      }
    });
  })

  const resizeInput = function (input, buttonElement) {
    const buttonSize = buttonElement.getBoundingClientRect();
    input.style.width = buttonSize.width + 'px';
    input.style.height = buttonSize.height + 'px';
  }
}
